$(function () {
  $('body').on('click','#swipebox-overlay',function (e) {
    if(!$(e.target).is('img') && !$(e.target).is('#swipebox-arrows')) {
      $(e.currentTarget).find('#swipebox-close').trigger('click');
    }
  })
})
